// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__343Y9","colMaxWidth":"Table_colMaxWidth__NIIEk"};